import React from 'react';
import PropTypes from 'prop-types';
import { PortalJoinButton } from '../../PortalButton/PortalJoinButton';
import './PortalSubscriptionPayment.scss';

export const PortalSubscriptionPayment = function ({
  onClick,
  isEnrolled,
  onCtaButtonClicked,
}) {
  return (
    <portal-subscription-payment>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <PortalJoinButton {...{ onClick, isEnrolled, onCtaButtonClicked }} />
        </div>
      </div>
    </portal-subscription-payment>
  );
};
PortalSubscriptionPayment.displayName = 'PortalSubscriptionPayment';
PortalSubscriptionPayment.propTypes = {
  onClick: PropTypes.func.isRequired,
  onCtaButtonClicked: PropTypes.func.isRequired,
  isEnrolled: PropTypes.bool,
};
PortalSubscriptionPayment.defaultProps = {
  isEnrolled: false,
};
